<template>
  <div v-if="show" class="dialog-add-account__form-type">
    <label :class="{ active: !value }" class="form-control">
      <input type="radio" :checked="!value" :disabled="disabled" @change="onChange(false)" />
      {{ $t('business_account_data.individual') }}
    </label>
    <label :class="{ active: value }" class="form-control">
      <input type="radio" :checked="value" :disabled="disabled" @change="onChange(true)" />
      {{ $t('business_account_data.ent_or_legal') }}
    </label>
  </div>
</template>

<script>
import { reachBusinessTypeGoal } from '@/utils/metrika';

export default {
  name: 'AccountTypeSwitcher',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(isLegal) {
      this.$emit('input', isLegal);
      reachBusinessTypeGoal(this, isLegal);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';
</style>
